module.exports = __webpack_public_path__ + "a68ebb73b2f1b3687cd5b4e01e4679ee.png";